import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useCasinoFreeSpinGameIds } from './use-casino-free-spins';
import { getCasinoGamesByIds } from './use-casino-game-history';
import { isCasinoGameAvailableOnPlatform } from './use-casino-games';

/*
    Builds a layout object for the games a user has active Free Spins on.
*/
export const useFreeSpinGames = () => {
    const { data: freeSpinGameIds = [], isLoading: isLoadingIds } = useCasinoFreeSpinGameIds();

    const query = useQuery({
        queryKey: ['free-spin-games', freeSpinGameIds],
        queryFn: async () => {
            if (!freeSpinGameIds || freeSpinGameIds.length === 0) {
                return null;
            }

            const gamesData = await getCasinoGamesByIds(freeSpinGameIds);
            const orderedGames = freeSpinGameIds
                .map(id => gamesData.items.find(game => game.id === id))
                .filter((game): game is (typeof gamesData.items)[0] => game !== undefined)
                .filter(isCasinoGameAvailableOnPlatform);

            return {
                id: 'free-spins',
                items: orderedGames,
            };
        },
        placeholderData: keepPreviousData,
    });

    return {
        data: query.data,
        isLoading: isLoadingIds || (freeSpinGameIds.length > 0 && !query.data && query.isFetching),
    };
};
